import view from '@/mixins/view'

import { populate, sort, filter } from '@/data'

export default {
  name: 'single-partner',
  mixins: [view],
  data () {
    return {
      page: null,
      works: []
    }
  },
  created () {
    this.getPage().then(() => {
      if (!this.page) this.$router.push({ name: 'not-found' })
      this.preloadAssets().then(() => {
        this.ready = true
      })
    })
  },
  methods: {
    fetchData: async function (store, params) {
      return Promise.all([
        store.getters.get(params.post_type, params.slug, true),
        store.getters.get('work'),
        store.getters.get('partner'),
        store.getters.get('industry'),
        store.getters.get('activity')

      ]).then(([page, works, partners, industries, activities]) => {
        return { page, works, partners, industries, activities }
      })
    },
    preloadAssets: async function () {
      return this.fetch(this.getCleanLink(this.getImageUrl(this.page.meta.cover.image_desktop, 'cover-desktop')))
    },
    getPage: async function () {
      await this.fetchData(this.$store, Object.assign({}, this.$attrs, this.$route.params)).then(({ page, works, partners, industries, activities }) => {
        page = populate(page, industries, 'industry')
        works = sort(works, 'title', 'asc')
        works = filter(works, 'partner', page.id)
        works = populate(works, partners, 'partner')
        works = populate(works, activities, 'activities')
        let filteredActivities = []
        works.forEach(work => {
          if (work.post_status === 'published') {
            filteredActivities.push(...work.meta.activities)
          }
        })
        let filteredActivitiesIds = []
        let filteredActivitiesUnique = []

        filteredActivities.forEach(activity => {
          if (!filteredActivitiesIds.includes(activity.id)) {
            filteredActivitiesIds.push(activity.id)
            filteredActivitiesUnique.push(activity)
          }
        })
        filteredActivitiesUnique = sort(filteredActivitiesUnique, 'title', 'asc')

        this.page = page
        this.works = works
        this.activities = filteredActivitiesUnique
      })
    }
  }
}
